import React, {Component} from 'react';

export default class SystemManage extends Component{
    render(){
        return (
            <div>下载</div>
        )
    }
}
